import React, { useEffect, useRef, useState } from 'react';
import '../css/main.css';

import portimg from '../img/231shots_so.png';
import otuaimg from '../img/775shots_so.png';
import sboximg from '../img/774shots_so.png';
import otuastudy from '../img/563shots_so.png';
import raon from '../img/491shots_so.png';
import crosstarget from '../img/217shots_so.png';
import shco from '../img/828shots_so.png';
import boknabi from '../img/127shots_so.png'
import buyeo from "../img/21_1x_shots_so.png"
import todayhome from "../img/716shots_so.png"

function Main() {
    const boxRefs = useRef([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const workItems = [
        {
            id: 1,
            title: 'S-BOX ',
            time: '퍼블리싱 100%, 디자인 100%',
            content: '별도의 디자인 시안을 받지않고 작업한 웹페이지 입니다. html,css,javascript로 작업하였습니다.',
            btn: 'http://s-box.co.kr/',
            img: sboximg
        },
        {
            id: 2,
            title: '오투아(Otua)',
            time: '퍼블리싱 100%, 디자인 100%',
            content: '별도의 디자인 시안을 받지않고 작업한 웹페이지 입니다. html,css,javascript로 작업하였습니다.',
            btn: 'http://otua.co.kr/',
            img: otuaimg
        },
        {
            id: 3,
            title: 'raon',
            time:  '퍼블리싱 100%, 디자인 100%',
            content: '별도의 디자인 시안을 받지않고 작업한 웹페이지 입니다. html,css,javascript로 작업하였습니다.',
            btn: 'http://otua.co.kr/raon/',
            img: raon
        },
        {
            id: 4,
            title: 'Otua-Study',
            time: '퍼블리싱 100%, 디자인 100%',
            content: '별도의 디자인 시안을 받지않고 작업한 웹페이지 입니다. html,css,javascript로 작업하였습니다.',
            btn: 'http://study.otua.co.kr/',
            img: otuastudy
        },
    ];
    const portItems = [
        {
            id: 1,
            title: '2024 포트폴리오',
            time: '퍼블리싱 100%, 디자인 100%',
            content: '현재 보고계시는 포트폴리오 웹페이지 입니다. React, html, scss를 활용하여 작업하였습니다. 이전 버전 포트폴리오는 github에 코드가 올라가있습니다.',
            btn: '/',
            img: portimg
        },
        {
            id: 2,
            title: '부여문화재야행',
            time: '퍼블리싱 100%',
            content: '포트폴리오 용도로 작업한 웹페이지 입니다. 이전에는 node.js와 ejs를 이용해 작업했던 포트폴리오를 React로 다시 작업 해보았습니다. 이전 작업물은 github에 코드가 올라가있습니다.',
            btn: 'https://summerryu.github.io/buyeo_2/',
            img: buyeo
        },
        {
            id: 3,
            title: '오늘의집',
            time: '퍼블리싱 100%, 디자인 50% [기존 디자인을 살짝씩 바꾸어 작업했습니다.]',
            content: '포트폴리오 용도로 작업한 웹페이지 입니다. 단일 메인페이지만 작업되어있습니다.주로 React를 이용한 html,scss,javascript로 만들어진 페이지 입니다. 본 작업물은 github에 코드가 올라가있습니다.',
            btn: 'https://summerryu.github.io/todayhome/',
            img: todayhome
        },
        {
            id: 4,
            title: 'Cross Target',
            time: '퍼블리싱 100%',
            content: '포트폴리오 용도로 작업한 웹페이지 입니다. 단일 메인페이지만 작업되어있습니다 , html로 하드코딩한 작업물 입니다. html,css,javascript를 사용했습니다. 본 작업물은 github에 코드가 올라가있습니다.',
            btn: 'https://summerryu.github.io/crosstarget/',
            img: crosstarget
        },
        {
            id: 5,
            title: '서초좋은클리닉',
            time: '퍼블리싱 100%',
            content: '포트폴리오 용도로 작업한 웹페이지 입니다. 단일 메인페이지만 작업되어있습니다 , html로 하드코딩한 작업물 입니다. html,css,javascript를 사용했습니다. 본 작업물은 구글웹클라우드플랫폼을 활용해 배포하였습니다.',
            btn: 'https://port2-430502.du.r.appspot.com/',
            img: shco
        },
        {
            id: 6,
            title: '복나비 한복',
            time: '퍼블리싱 100%, 디자인 50% [기존 디자인을 살짝씩 바꾸어 작업했습니다.]',
            content:  '포트폴리오 용도로 작업한 웹페이지 입니다. 이전에는 node.js와 ejs를 이용해 작업했던 포트폴리오를 React로 다시 작업 해보았습니다. 이전 작업물은 github에 코드가 올라가있습니다.',
            btn: 'https://summerryu.github.io/boknabi/',
            img: boknabi
        },
    ];
    const openModal = (itemId, type) => {
        const item = type === 'work'
            ? workItems.find(item => item.id === itemId)
            : portItems.find(item => item.id === itemId);

        setSelectedItem(item);
        document.querySelector('.modal__wrap').classList.add('is-open');
        document.body.style.overflow = 'hidden'; 
    };
    const closeModal = () => {
        setSelectedItem(null);
        document.querySelector('.modal__wrap').classList.remove('is-open');
        document.body.style.overflow = 'auto';
    };

    useEffect(() => {
        const handleScroll = () => {
            const scTop = window.scrollY;
            boxRefs.current.forEach((box, i) => {
                if (box) {
                    box.style.transform = `translateZ(${-1000 * i + scTop}px)`;
                }
            });
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const gitButtonClick = () => {
        window.open('https://github.com/summerryu', '_blank', 'noopener,noreferrer');
    };
    return (
        <div className="Main_container">
            <div className="Main_bg"></div>
            <div className="Main_content">
                <div className="boxs main" ref={el => boxRefs.current[0] = el}>
                    <h1>
                        Yeoreum<br></br>
                        <span>Portfolio</span>
                    </h1>
                </div>
                <div className="boxs" ref={el => boxRefs.current[1] = el}>
                    <section className="About">
                        <div className='title'>About</div>
                        <div className="About_menu">
                            <div>
                                <span>01</span>
                                <p>SKIL</p>
                                <ul>
                                    <li>HTML ,CSS ,SASS[SCSS] ,React ,Javascript jQuery</li>
                                    <li>Git, Vscode, Eclipse, MongoDB, Node.js</li>
                                </ul>
                            </div>
                            <div>
                                <span>02</span>
                                <p>EXPERIENCE</p>
                                <ul>
                                    <li>오투아(Otua)<br></br>[퍼블리셔/개발팀]<br></br>23.10~24.0.7 [퇴사]</li>
                                </ul>
                            </div>
                            <div>
                                <span>03</span>
                                <p>EDUCATION</p>
                                <ul>
                                    <li>영남이공대학교 [식음료조리학과] 졸업</li>
                                    <li>더조은아카데미 [웹퍼블리셔 & 프론트엔드 개발 과정] 수료</li>
                                </ul>
                            </div>
                            <div>
                                <span>04</span>
                                <p>INFO</p>
                                <ul>
                                    <li>E-mail : saunogq2@naver.com</li>
                                    <li>GitHub : <a href="https://github.com/summerryu">github.com/summerryu</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className='About_me'>
                            <div className="AboutMe_area">
                                <ul>
                                    <li><span>유여름</span></li>
                                    <li>1996.07.23</li>
                                </ul>
                                <p>
                                    비전공자에 남들보다 조금 늦은 나이에 시작한 퍼블리싱 및 개발 관련 직종이
                                    제 인생의 전환점이 되어 앞으로의 미래 역시 개발 및 퍼블리싱,
                                    더 나아가 풀스택 개발자로 성장하고 싶습니다. 배움을 게을리하지 않고
                                    성실하게 공부하며 귀사의 없으면 안 되는, 대체될 수 없는 인력이 되고 싶습니다.
                                </p>
                            </div>
                            <div className="AboutMe_skils">
                                <div className="satellites">
                                    <p className="satellite">HTML</p>
                                    <p className="satellite">CSS</p>
                                    <p className="satellite">SASS</p>
                                    <p className="satellite">React</p>
                                </div>
                                <div className="satellites sub">
                                    <p className="satellite">Javascript</p>
                                    <p className="satellite">jQuery</p>
                                    <p className="satellite">Git</p>
                                    <p className="satellite">Vscode</p>
                                </div>
                                <div className="satellites sub">
                                    <p className="satellite">Vue</p>
                                    <p className="satellite">Eclipse</p>
                                    <p className="satellite">MongoDB</p>
                                    <p className="satellite">Node.js</p>
                                </div>

                            </div>
                        </div>
                    </section>
                </div>
                <div className="boxs" ref={el => boxRefs.current[2] = el}>
                    <section className='Port'>
                        <div className='title'>Portfolio</div>
                        <div className="Port_list">
                            {portItems.map(item => (
                                <div
                                    className="Port_item"
                                    key={item.id}
                                    data-id={item.id}
                                    onClick={() => openModal(item.id, 'portfolio')}
                                >
                                    <p>{item.title}</p>
                                </div>
                            ))}
                        </div>
                    </section>
                </div>
                <div className="boxs" ref={el => boxRefs.current[3] = el}>
                    <section className='Work'>
                        <div className='title'>Work</div>
                        <div className="Work_list">
                            {workItems.map(item => (
                                <div
                                    className="Work_item"
                                    key={item.id}
                                    data-id={item.id}
                                    onClick={() => openModal(item.id, 'work')}
                                >
                                    <p>{item.title}</p>
                                </div>
                            ))}
                        </div>
                        <p className='work_plus'>
                            저의 Work란은 아직 많이 부족합니다.<br></br>함께 일하며 채워나가고 싶습니다<br></br>
                            <a href="./yuyeoreum.pdf" download="yuyeoreum.pdf">
                                이 링크를 클릭하시면 이력서가 다운로드 됩니다.
                            </a>
                        </p>
                    </section>
                </div>
                <div className="modal__wrap">
                    {selectedItem && (
                        <div className="modal__card">
                            <header>
                                <div>
                                    <h3>{selectedItem.title}</h3>
                                    <div id="close" className="prev_btn" onClick={closeModal}>X</div>
                                </div>
                            </header>
                            <span>{selectedItem.time}</span>
                            <p>{selectedItem.content}</p>
                            <button className="Work_viewBtns">
                                <a href={selectedItem.btn} target="_blank" rel="noopener noreferrer">View</a>
                            </button>
                            <img src={selectedItem.img} alt={selectedItem.title} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Main;
